export const environment = {
  production: false,
  blauth: {
    clientId: 'bl-firm-support',
    scope: 'BL_T_A BL_ALL_INCLUSIVE BL_CLIENT_MANAGER',
    redirectURI: 'https://workflow-test.lundify.com/auth',
    env: 'dev', // dev, test, or empty for prod

    // SSO CONFIGS
    // ssoBaseUrl: 'http://localhost:8082/oauth-agent',
    ssoOauthAgentUrl: 'https://workflow-test.lundify.com/oauth-agent',
    cookieNamePrefix: 'lundify-test',
    csrfTokenName: 'x-lundify-test-csrf',
    blAccountAcrValue: 'urn:se:curity:authentication:html-form:BL-Konto',
  },
  serverUrl: {
    withSSO: 'https://workflow-test.lundify.com/api/',
    withLegacy: 'https://workflow-test.lundify.com/jwt/',
  },

  loginUrl: 'https://workflow-test.lundify.com/login',
  documentUrl: 'https://docgenerator.k8s-test.bjornlunden.com',
  blappWeb: 'https://test.lundify.com',
  chatServer: 'https://chat-app-test.bjornlunden.se',
  version: 'CI_VERSION_TAG',
  name: 'Test',
  startPageUrl: {
    SE: 'https://www.bjornlunden.se/byststart',
    NL: 'https://combjornl-guandi.savviihq.com/nl/kennisbank/workflow',
  },
  termsOfAggrementUrl: {
    SE: 'https://www.bjornlunden.se/program/avtalsvillkor-redovisningsbyraer',
    NL: 'https://www.bjornlunden.com/nl/privacy-verklaring/lundify/',
  },
  sdkKey: 'Iy_aCNVU7E6IGx-j0R9XvQ/mXKue_dY6UuXjmCQbMXzUg',
  sustainabiltyUrl: 'https://demo.wellfish.se',
  messagingUrl: 'wss://centrifugo.blinfo.se/connection/websocket',
  messagingNamespace: 'workflow-test',
  forms: {
    giveFeedback: {
      sv: 'HR4vJO4X',
      en: 'lSEvcBnT',
      nl: 'IbSu8ytT',
    },
  },
  matomo: {
    active: true,
    siteId: 12, // 12 = test site id
    url: 'https://matomo.blinfo.se/',
    // scriptUrl: 'https://matomo.blinfo.se/matomo.js',
  },
};
